import { Exclude, Type } from 'class-transformer';

export class WorkOrderProposalResultDto {
    proposalId: number;
    vendorName: string;

    @Type(() => Date)
    lastGenerated: Date;

    hasRfpDocument: boolean;
    estimatedAmount: number;
    allowRemoveProposal: boolean;
    attachmentCount: number;
    rpfDownloadUrl: string;

    @Exclude()
    proposalVendorType: string;
    @Exclude()
    proposalVendorId: number;
}
